// extracted by mini-css-extract-plugin
export var googleLogo = "SiteReviews-module--googleLogo--gSGCH";
export var rating = "SiteReviews-module--rating--8s4Ef";
export var reviewContainer = "SiteReviews-module--reviewContainer--UXHXK";
export var reviewText = "SiteReviews-module--reviewText--F3DY1";
export var siteReviews = "SiteReviews-module--siteReviews--JilhO";
export var stars = "SiteReviews-module--stars--yzU24";